var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6347 16.9052C5.64021 16.7767 0.887401 13.4369 0.930219 9.36917C1.01585 5.30145 5.89712 2.09009 11.8488 2.17572C17.8434 2.26136 22.5962 5.64399 22.5534 9.71172C22.4677 13.7794 17.5865 16.9908 11.6347 16.9052V16.9052Z",
    fill: "url(#paint0_linear_1_252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8915 0.548572C17.8432 0.634208 22.6388 4.01684 22.5532 8.08456V9.71165C22.596 5.64393 17.8432 2.2613 11.8486 2.17566C5.89693 2.09002 1.01566 5.30138 0.930023 9.36911L0.972842 7.74202C1.01566 3.67429 5.89693 0.462935 11.8915 0.548572V0.548572Z",
    fill: "url(#paint1_linear_1_252)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6353 16.4346C6.24026 16.349 1.95845 13.3089 2.00126 9.62656C2.0869 5.98702 6.45435 3.07539 11.8494 3.16102C17.2017 3.24666 21.5263 6.28674 21.4407 9.9691C21.3979 13.6086 16.9876 16.5203 11.6353 16.4346Z",
    fill: "url(#paint2_linear_1_252)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4407 9.79738C21.4407 9.85447 21.4407 9.91155 21.4407 9.96865C21.3979 13.6082 16.9876 16.5198 11.6353 16.4342C6.24026 16.3485 1.95845 13.3085 2.00126 9.62611C2.00126 9.59756 2.00126 9.55474 2.00126 9.49765C2.0869 13.0944 6.32589 16.0488 11.6353 16.1345C16.9448 16.2201 21.3122 13.3941 21.4407 9.79738V9.79738Z",
    fill: "#A86314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_252",
    x1: 24.3089,
    y1: 2.21854,
    x2: 24.052,
    y2: 18.1897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_252",
    x1: 0.0308427,
    y1: -1.24979,
    x2: 19.8128,
    y2: -0.950063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_252",
    x1: 23.6672,
    y1: -16.6209,
    x2: 22.8965,
    y2: 21.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin17);
export default __webpack_public_path__ + "static/media/coin17.cee50f071bb1ee0eb2b9789e5df7366e.svg";
export { ForwardRef as ReactComponent };